<!-- app.topbar.html -->
<div class="layout-topbar">
	<div class="layout-topbar-logo-container">
		<button class="layout-menu-button layout-topbar-action circular-button" (click)="layoutService.onMenuToggle()">
			<i class="pi pi-bars"></i>
		</button>
		<a class="layout-topbar-logo" routerLink="/">
			<span class="layout-topbar-logo-icons">
				<svg class="layout-topbar-logo-svg layout-topbar-logo-boy layout-topbar-logo-boy-1" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="330 150 190 345"
					preserveAspectRatio="xMidYMid meet">
					<g id="topbar-logo-boy" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor">
						<path d="M399,170.28c38.878-8.291,40.364,46.542,11,50C375.303,224.367,368.569,176.77,399,170.28z" />
						<path d="M442,272.28c-0.633,24.869,9.327,46.222,4,68c-5.903,24.136-37.013,44.856-47,67c-11.496,25.489-5.946,50.991-25,71c-33.303,2.82-19.163-26.885-13-48c4.013-13.749,5.813-25.746,11-37c8.355-18.126,22.972-30.485,30-43c-2.152-18.294-3.486-35.013-5-54c-1.339-16.785-6.683-38.898-3-53c2.89-11.064,18.911-21.636,36-16c7.706,2.541,16.769,14.632,24,23c5.838,6.756,17.334,17.705,21,26c4.114,9.309,3.882,18.458,7,32c2.254,9.789,15.021,44.22-9,36c-11.104-3.8-11.122-43.083-16-55C453.718,281.262,446.384,277.764,442,272.28z" />
						<path d="M387,267.28c-0.458,14.069,6.863,27.624,4,39c-1.804,7.168-15.489,14.407-21,19c-8.232,6.86-15.15,16.31-26,14c-17.648-21.076,27.233-34.097,36-48C385.326,282.833,381.394,276.453,387,267.28z" />
						<path d="M420,390.28c7.969-10.698,15.411-21.922,24-32c6.208,14.341,4.885,27.463,11,42c4.19,9.961,14.55,21.514,21,31c6.114,8.992,19.383,22.255,17,34c-1.512,7.451-12.166,11.953-19,11c-9.796-1.366-18.537-19.308-25-29C435.88,427.606,425.267,415.255,420,390.28z" />
					</g>
				</svg>
				<svg class="layout-topbar-logo-svg layout-topbar-logo-boy layout-topbar-logo-boy-2" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="330 150 190 345"
					preserveAspectRatio="xMidYMid meet" aria-hidden="true">
					<use href="#topbar-logo-boy"></use>
				</svg>
				<svg class="layout-topbar-logo-svg layout-topbar-logo-boy layout-topbar-logo-boy-3" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="330 150 190 345"
					preserveAspectRatio="xMidYMid meet" aria-hidden="true">
					<use href="#topbar-logo-boy"></use>
				</svg>
			</span>

				<span>
					{{ titleMsg$ | async }}
				</span>
		</a>
	</div>

	<div class="layout-topbar-actions">
		<div class="layout-config-menu">
			<div class="relative">
				<button class="layout-topbar-action layout-topbar-action-highlight" pStyleClass="@next"
					enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden"
					leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
					<i class="pi pi-palette"></i>
				</button>
				<app-configurator />
			</div>
			<button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
				<i
					[ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
			</button>
		</div>

		<div class="layout-topbar-menu hidden lg:block">
			<div class="layout-topbar-menu-content">

				<!-- Language Selector -->
				<p-overlayPanel #langMenu>
					<div class="flex flex-col gap-2 p-2">
						<button type="button" (click)="changeLang('en'); langMenu.hide()"
							class="flex items-center justify-between hover:bg-gray-100 dark:hover:bg-gray-700 p-2 rounded cursor-pointer">
							<div class="flex items-center gap-2">
								<img src="https://flagcdn.com/28x21/us.png"
									srcset="https://flagcdn.com/56x42/us.png 2x, https://flagcdn.com/84x63/us.png 3x"
									width="28" height="21" alt="United States">
								<span>English</span>
							</div>
							<span *ngIf="currentLang === 'en'" class="text-green-500 pi pi-check"></span>
						</button>

						<button type="button" (click)="changeLang('he'); langMenu.hide()"
							class="flex items-center justify-between hover:bg-gray-100 dark:hover:bg-gray-700 p-2 rounded cursor-pointer">
							<div class="flex items-center gap-2">
								<img src="https://flagcdn.com/28x21/il.png"
									srcset="https://flagcdn.com/56x42/il.png 2x, https://flagcdn.com/84x63/il.png 3x"
									width="28" height="21" alt="Israel">
								<span>עברית</span>
							</div>
							<span *ngIf="currentLang === 'he'" class="text-green-500 pi pi-check"></span>
						</button>
					</div>
				</p-overlayPanel>

				<button type="button" class="layout-topbar-action" (click)="langMenu.toggle($event)">
					<i class="pi pi-globe"></i>
				</button>

				<!-- NEW: User Popover Component -->
				<app-user-popover
					(signOutClicked)="signOut()"
					(profileClicked)="navigateToProfile()"
					(settingsClicked)="navigateToSettings()"></app-user-popover>
			</div>
		</div>
	</div>
</div>